__turbopack_context__.v({
  "breadcrumbWrap": "Deals-module__ncqcza__breadcrumbWrap",
  "categoryBar": "Deals-module__ncqcza__categoryBar",
  "categoryIcon": "Deals-module__ncqcza__categoryIcon",
  "categoryIconActive": "Deals-module__ncqcza__categoryIconActive",
  "categoryTab": "Deals-module__ncqcza__categoryTab",
  "categoryTabActive": "Deals-module__ncqcza__categoryTabActive",
  "categoryTabs": "Deals-module__ncqcza__categoryTabs",
  "emptyState": "Deals-module__ncqcza__emptyState",
  "loadingWrap": "Deals-module__ncqcza__loadingWrap",
  "page": "Deals-module__ncqcza__page",
  "regionSelect": "Deals-module__ncqcza__regionSelect",
  "regionSelectChevron": "Deals-module__ncqcza__regionSelectChevron",
  "regionSelectWrap": "Deals-module__ncqcza__regionSelectWrap",
  "regionTab": "Deals-module__ncqcza__regionTab",
  "regionTabActive": "Deals-module__ncqcza__regionTabActive",
  "regionTabs": "Deals-module__ncqcza__regionTabs",
  "sectionBlock": "Deals-module__ncqcza__sectionBlock",
  "sectionSelect": "Deals-module__ncqcza__sectionSelect",
  "sectionSelectChevron": "Deals-module__ncqcza__sectionSelectChevron",
  "sectionSelectInner": "Deals-module__ncqcza__sectionSelectInner",
  "sectionSelectWrap": "Deals-module__ncqcza__sectionSelectWrap",
});
